import { DecimalPipe } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';

import * as XLSX from 'xlsx';
import { DecimalPipePipe } from '../../pipes/decimal-pipe.pipe';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { HttpService } from '../../services/http.service';

@Component({
  selector: 'app-excel-to-table',
  templateUrl: './excel-to-table.component.html',
  styleUrls: ['./excel-to-table.component.scss'],
})
export class ExcelToTableComponent extends DecimalPipePipe {
  data: any;
  actualData: any;
  refinedData: any;
  largestSheetName: string | undefined;
  columnList: any;
  combolist: any;
  pivotedData: any = [];
  pivotTableHeader: any = ['Kilometers / Kilograms', 'Range', 'Price'];
  maxLengthItem: any;

  workbook: XLSX.WorkBook | null = null;
  sheetNames: string[] = [];
  selectedSheet: string | null = null;
  sheetData: any[] = [];
  isREfineTableVisible = false;
  surgeChargeArray: { [x: number]: any }[] = [];
  MautChargeArray: { [x: number]: any }[] = [];
  AdditionalChargeArray: { [x: number]: any }[] = [];

  constructor(
    public dialogRef: MatDialogRef<ExcelToTableComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
    private httpService: HttpService
  ) {
    super();
    dialogRef.disableClose = true;
  }

  onColDelete(key: any, val: any) {
    this.data = this.data.map((item: any) => {
      const { [key]: _, ...rest } = item;
      return rest;
    });
    this.isREfineTableVisible = false;
    this.findLargestLength();
  }

  onRowDelete(val: any) {
    this.data.splice(val, 1);
    this.isREfineTableVisible = false;
  }

  onFileChange(evt: any) {
    const selectedFiles: any = (evt.target as HTMLInputElement).files;
    const allowedFormats = ['xlsx', 'xls'];
    const fileType = selectedFiles[0].name.split('.').pop().toLowerCase();
    if (!allowedFormats.includes(fileType)) {
      this.httpService.openSnackBar(
        `Invalid file format. Allowed formats: ${allowedFormats.join(', ')}`
      );
      return; // Skip this file and move to the next one
    }
    this.data = [];
    this.refinedData = [];
    this.pivotedData = [];

    this.isREfineTableVisible = false;
    this.sheetNames = [];
    const target: DataTransfer = <DataTransfer>evt.target;
    if (target.files.length !== 1) throw new Error('Cannot use multiple files');

    const reader: FileReader = new FileReader();

    reader.onload = (e: any) => {
      const bstr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });
      let largestSize = 0;

      this.workbook = wb;
      this.sheetNames = wb.SheetNames;
      this.selectedSheet = null;
      this.sheetData = [];
    };
    reader.readAsBinaryString(target.files[0]);
  }

  onSheetSelect(sheetName: any) {
    if (this.workbook) {
      this.data = [];
      this.refinedData = [];
      this.pivotedData = [];
      this.surgeChargeArray = [];

      this.isREfineTableVisible = false;
      this.selectedSheet = sheetName.value;
      this.sheetData = this.getSheetData(this.workbook, sheetName.value);
    }
  }

  public getSheetData(wb: XLSX.WorkBook, sheetName: string): any[] {
    const ws: XLSX.WorkSheet = wb.Sheets[sheetName];
    // wb.SheetNames.forEach((sheetName) => {
    // const ws: XLSX.WorkSheet = wb.Sheets[sheetName];
    const data = XLSX.utils.sheet_to_json(ws);
    let largestSize = 0;
    // Do something with the data
    const jsonData = XLSX.utils.sheet_to_json(ws, { header: 'A' });
    const size =
      jsonData.length * (jsonData[0] ? Object.keys(jsonData[0]).length : 0);

    if (size > largestSize) {
      largestSize = size;
      this.largestSheetName = sheetName;
      this.data = jsonData;
      this.actualData = [...this.data];
      if (this.actualData) this.findLargestLength();
    }
    // });
    return XLSX.utils.sheet_to_json(ws, { header: 1 });
  }

  findLargestLength() {
    // this.maxLengthItem = this.data.reduce((acc: any, item: any) => {
    //   return Object.keys(acc).length > Object.keys(item).length ? acc : item;
    // })

    // console.log("maxLengthItem",this.data,this.maxLengthItem);

    // this.findMaxStringLength(length);
    //
    let data = this.data;
    let largestField = '';
    let largestValue: any = '';

    data.forEach((obj: any) => {
      Object.entries(obj).forEach(([key, value]) => {
        if (key > largestField) {
          largestField = key;
          largestValue = value;
        }
      });
    });
    this.maxLengthItem = data.find((obj: any) => largestField in obj);
    this.columnList = this.maxLengthItem ? Object.keys(this.maxLengthItem) : [];
  }

  findMaxStringLength(obj: any) {
    let val = Object.values(obj);
    for (let i = val.length - 1; i >= 0; i--) {
      if (typeof val[i] === 'string') {
        return 0;
      }
    }
    return 0;
  }

  public onRefineTable() {
    this.isREfineTableVisible = true;
    this.refinedData = [...this.data];
    this.combolist = Object.keys(this.maxLengthItem);
    this.columnList = this.maxLengthItem ? Object.keys(this.maxLengthItem) : [];
  }

  public onTableToData() {
    this.pivotedData = [];
    let colmnKeys = Object.keys(this.data[0]);
    let colHeadKey = colmnKeys[0];

    if (this.dialogData.screen === 'ltl') {
      let rowHeadsValues = this.refinedData[0]
        ? Object.values(this.refinedData[0])
        : null;
      if (!rowHeadsValues?.includes('Kilometers / Kilograms')) {
        this.httpService.openSnackBar('Please Upload the Correct File');
        return;
      }
      let colkeyData = this.getDataOfKey(this.refinedData, colHeadKey);
      if (colkeyData.length < 15 || colkeyData.length > 15) {
        this.httpService.openSnackBar('Please Upload the Correct File');
        return;
      }
      rowHeadsValues?.shift();
      colkeyData?.shift();
      this.onPivotTableConversion(this.refinedData, colHeadKey);
    } else if (this.dialogData.screen === 'ftl') {
      const dataArray = [];
      const keys = Object.keys(this.data[0]);
      let targetNames = [
        'Kilometer ranges / Prices',
        'SINGLE TRIP INBOUND km rate',
        'ROUNDTRIP km rate',
        'SINGLE TRIP RETURN km rate',
      ];

      // const filteredKeys = keys.filter(key => targetNames.some(name => this.data[0][key].includes(name)));
      const filteredKeys = keys.filter((key) => {
        let value = this.data[0][key];
        if (typeof value === 'number') {
          value = '' + value;
        }
        return targetNames.some((name) => value.includes(name));
      });

      if (filteredKeys.length === 0) {
        this.httpService.openSnackBar('Please Upload the Correct File');
        return;
      }
      const nextKey = Object.keys(this.data[0]).find(
        (key) => !filteredKeys.includes(key)
      );

      const startIndex = keys.findIndex((key) => key === nextKey);

      if (this.data.length !== 16) {
        this.httpService.openSnackBar('Please Upload the Correct File');
        return;
      }

      for (let i = startIndex; i < keys.length; i++) {
        const key = keys[i];
        const value = this.data[0][key];
        const newObj = { [value]: this.data[15][key] };
        dataArray.push(newObj);
      }

      let allKeys = this.refinedData.map((i: any) => i[keys[0]]);
      if (allKeys.length !== 16) {
        this.httpService.openSnackBar('Please Upload the Correct File');
        return;
      }
      if (
        !(
          allKeys.length === 16 &&
          allKeys[0].toLowerCase().includes('kilometer') &&
          allKeys[15].toLowerCase().includes('surcharge')
        )
      ) {
        this.httpService.openSnackBar('Please Upload the Correct File');
        return;
      }

      this.surgeChargeArray = nextKey ? [...dataArray] : []; // surcharge aray
      this.surgeChargeArray.forEach((item: any) => {
        const key = Object.keys(item)[0];
        const value = item[key];

        if (key.includes('toll')) {
          // Extract the country name by removing ' toll' from the key
          const country = key.replace(' toll', '');
          this.MautChargeArray.push({ [country]: value });
        } else {
          this.AdditionalChargeArray.push(item);
        }
      });

      // console.log('refinedData', this.refinedData);
      this.refinedData.pop();
      const filteredArray = this.refinedData.map((obj: any) => {
        const filteredObj: any = {};
        filteredKeys.forEach((key) => {
          if (obj.hasOwnProperty(key)) {
            filteredObj[key] = obj[key];
          }
        });
        return filteredObj;
      });
      this.onPivotTableConversion(filteredArray, colHeadKey);
    }
  }

  getDataOfKey(data: any[], key: string) {
    return data.map((item) => item[key]);
  }

  onPivotTableConversion(data: any, key: any) {
    let maxStrlenth = this.findMaxStringLength(this.maxLengthItem);
    let val = Object.values(data[0]);

    let headerItem = val.map((item: any, index: number) => {
      if (index === 0) {
        return item;
      } else if (!item.includes('-')) {
        return item + '-+';
      } else {
        return item;
      }
    });
    let objItems: any = headerItem.slice(0, maxStrlenth + 1);
    this.pivotTableHeader = [...objItems, 'Range', 'Price'];

    let colmnKeys: any = Object.keys(data[0]);
    for (let i = 1; i < data.length; i++) {
      let dataVal = data[i];
      let colData = data[0];
      for (let j = maxStrlenth + 1; j < colmnKeys.length; j++) {
        let id = colmnKeys[j];
        let obj: any = {
          Range: colData[id] ? colData[id] : null,
          Price: dataVal[id] ? dataVal[id] : null,
        };
        objItems.forEach((element: any, ind: any) => {
          let k = colmnKeys[ind];
          obj[element] = dataVal[k];
        });
        this.pivotedData.push(obj);
      }
    }
    // ltl ------------------
    if (this.dialogData.screen === 'ltl') {
      const transformedArray = this.pivotedData.map((obj: any) => {
        const range =
          obj['Kilometers / Kilograms'] || obj['Kilometer ranges / Prices'];
        const [from, to] = range.split('-');

        const newObj: any = {
          from,
          to,
          // LTLCost: obj['Price'] ? obj['Price'] : 0,
          // LTLWeight:obj.Range
        };
        newObj[obj.Range] = obj.Price ? obj.Price.toFixed(2) : null;
        return newObj;
      });

      this.dialogRef.close({
        operation: 'save',
        data: transformedArray,
        type: 'ltl',
      });
    } else if (this.dialogData.screen === 'ftl') {
      const transformedArray = this.pivotedData.map((obj: any) => {
        const range = obj['Kilometer ranges / Prices'];
        // const [from, to] = range.split('-');
        const newObj: any = {
          // from,
          // to: to ? to : '-',
          Weight: range,
          TrailerRateType: obj['Range'],
          FTLMatrixCost: obj['Price'] != null ? obj['Price'].toFixed(2) : null,
          AdditionalCostItem:
            this.AdditionalChargeArray.length > 0
              ? this.AdditionalChargeArray.map(
                  (obj) => Object.keys(obj)[0]
                ).join(', ')
              : null,
          AdditionalCost:
            this.AdditionalChargeArray.length > 0
              ? this.AdditionalChargeArray.map(
                  (obj) => Object.values(obj)[0]
                ).join(', ')
              : null,
          // MautCountry:this.MautChargeArray.length>0?this.MautChargeArray.map(obj => Object.keys(obj)[0]).join(', '):null,
          // MautCountryCost:this.MautChargeArray.length>0?this.MautChargeArray.map(obj => Object.values(obj)[0]).join(', '):null,
        };
        // newObj[obj.Range] = obj.Price;
        return newObj;
      });
      this.dialogRef.close({
        operation: 'save',
        data: transformedArray,
        type: 'ftl',
        surcharge: this.AdditionalChargeArray,
        // maut:this.MautChargeArray
      });
    }
  }

  onCloseBtn() {
    this.dialogRef.close({ operation: 'close' });
  }
}
